<template>
  <span class="dropdown">
    <button
      class="btn btn-outline-primary me-3 dropdown-toggle"
      :class="{ 'btn-sm': small }"
      type="button"
      data-bs-toggle="dropdown"
      aria-expanded="false"
    >
      <span class="fas fa-copy"></span> Copiar URL
    </button>
    <ul class="dropdown-menu py-0">
      <li v-for="link in $helper.hyperlinks" v-bind:key="link.id">
        <template>
          <a
            role="button"
            class="dropdown-item p-3"
            @click.prevent="$emit('onSelected', link)"
          >
            <span
              :class="`badge border fw-bold text-uppercase ${link.container}`"
            >
              <span :class="`${link.icon}`"></span>
              {{ link.name }}
            </span>
          </a>
          <li><hr class="dropdown-divider my-0" /></li>
        </template>
      </li>
    </ul>
  </span>
</template>
<script>
export default {
  emits: ["onSelected"],
  props: {
    small: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
};
</script>
<style scoped>
.dropdown-item:hover {
  background-color: #f5f5f5 !important ;
}
</style>
